import React from 'react';
import Icon from '../AppIcon';

const TreatmentAlerts = ({ alerts = [], onAlertClick, onDismiss }) => {
  const handleAlertClick = (alert) => {
    if (onAlertClick) {
      onAlertClick(alert);
    }
  };

  const handleDismiss = (e, alertId) => {
    e?.stopPropagation();
    e?.preventDefault();
    if (onDismiss) {
      onDismiss(alertId);
    }
  };

  const getSeverityIcon = (severity) => {
    switch (severity) {
      case 'critical':
        return 'AlertCircle';
      case 'warning':
        return 'AlertTriangle';
      case 'info':
        return 'Info';
      default:
        return 'Bell';
    }
  };

  const getSeverityClass = (severity) => {
    switch (severity) {
      case 'critical':
        return 'treatment-alert critical';
      case 'warning':
        return 'treatment-alert warning';
      case 'info':
        return 'treatment-alert info';
      default:
        return 'treatment-alert';
    }
  };

  if (alerts?.length === 0) {
    return null;
  }

  return (
    <div className="space-y-2">
      {alerts?.map((alert) => (
        <button
          key={alert?.id}
          onClick={() => handleAlertClick(alert)}
          className={`${getSeverityClass(alert?.severity)} w-full text-left relative group`}
        >
          <Icon name={getSeverityIcon(alert?.severity)} size={20} className="flex-shrink-0" />
          
          <div className="flex-1 min-w-0">
            <div className="flex items-start justify-between gap-2">
              <p className="font-medium">{alert?.title}</p>
              {alert?.timestamp && (
                <span className="text-xs opacity-75 whitespace-nowrap">
                  {alert?.timestamp}
                </span>
              )}
            </div>
            <p className="text-sm opacity-90 mt-1">{alert?.message}</p>
            {alert?.actionRequired && (
              <p className="text-xs font-medium mt-2 opacity-90">
                Action Required: {alert?.actionRequired}
              </p>
            )}
          </div>

          {onDismiss && alert?.dismissible !== false && (
            <button
              onClick={(e) => handleDismiss(e, alert?.id)}
              className="flex-shrink-0 p-1.5 rounded-md hover:bg-black/20 transition-all ml-2 opacity-60 group-hover:opacity-100"
              aria-label="Dismiss alert"
              title="Dismiss alert"
            >
              <Icon name="X" size={18} />
            </button>
          )}

          <Icon name="ChevronRight" size={18} className="flex-shrink-0 opacity-60 group-hover:opacity-100 transition-opacity" />
        </button>
      ))}
    </div>
  );
};

export default TreatmentAlerts;